import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import menu_45access_45log_45global from "/app/middleware/menu-access-log.global.ts";
import permission_45global from "/app/middleware/permission.global.ts";
import tab_45global from "/app/middleware/tab.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  menu_45access_45log_45global,
  permission_45global,
  tab_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts")
}